import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { detectTrafficSource } from "./utils/detectTrafficSource";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "./components/Layout";
import Home from "./pages/home/Home";
import JoinUs from "./pages/join us/Join";
import ConactUsPage from "./pages/contact/Contact";
import AboutPage from "./pages/AboutUsPage/About";
import Projects from "./pages/Projects/Projects";
import DashboardLayout from "./components/DashboardLayout/DashboardLayout";
import Login from "./pages/dashboard/login/login";
import ForgetPassword from "./pages/dashboard/forget Password/forget";
import ChangePassword from "./pages/dashboard/change Password/changePassword";
import Profile from "./pages/dashboard/profile/profile";
import AddProject from "./pages/dashboard/add-project/AddProject";
import LastProjects from "./pages/dashboard/lastProjects/LastProjects";
import AddProduct from "./pages/dashboard/AddProduct/AddProduct";
import LastProducts from "./pages/dashboard/LastProducts/LastProducts";
import Messages from "./pages/dashboard/Messages/Messages";
import AddReview from "./pages/dashboard/AddReview/AddReview";
import LastReviews from "./pages/dashboard/LastReviews/LastReviews";
import AddPartner from "./pages/dashboard/AddPartner/AddPartner";
import About from "./pages/dashboard/Content/About";
import HomeDash from "./pages/dashboard/Content/Home";
import EditProduct from "./pages/dashboard/AddProduct/EditProduct";
import EditProject from "./pages/dashboard/add-project/EditProject";
import Jobs from "./pages/dashboard/Jobs/Jobs";
import EditReview from "./pages/dashboard/AddReview/EditReview";
import { useEffect } from "react";
import ScrollToTop from "./components/ScrollToTop";
import ContactJoin from "./pages/dashboard/Content/ContactJoin";
import Store from "./pages/store/Store";
import StoreLayout from "./pages/store/StoreLayout";
import Checkout from "./pages/store/Checkout";
import Wishlist from "./pages/store/Wishlist";
import StoreCategory from "./pages/store/StoreCategory";
import ProductDetail from "./pages/store/ProductDetail";
import MyOrders from "./pages/store/MyOrders";
import OrderDetail from "./pages/store/OrderDetail";
import StorePolicies from "./pages/store/StorePolicies";
import Orders from "./pages/dashboard/Orders/Orders";
import { StoreAuthProvider } from "./pages/store/StoreAuthContext";
import { StoreCartProvider } from "./pages/store/StoreCartContext";
import DashboardIndex from "./pages/dashboard/DashboardIndex";
import DashboardOrderDetail from "./pages/dashboard/Orders/DashboardOrderDetail";
import Notifications from "./pages/dashboard/Notifications/Notifications";
import StoreControl from "./pages/dashboard/StoreControl/StoreControl";
import DashboardPolicies from "./pages/dashboard/Policies/DashboardPolicies";
import StoreProductReviews from "./pages/dashboard/StoreProductReviews/StoreProductReviews";

function VisitorPing() {
  useEffect(() => {
    let sessionId = sessionStorage.getItem("_vsid");
    if (!sessionId) {
      sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("_vsid", sessionId);
    }
    const ping = () => axios.post("analytics/ping", { sessionId }).catch(() => {});
    ping();
    const interval = setInterval(ping, 30000);

    // Track traffic source once per session
    if (!sessionStorage.getItem("_src_tracked")) {
      const source = detectTrafficSource();
      axios.post("analytics/event", { type: "traffic_source", source }).catch(() => {});
      sessionStorage.setItem("_src_tracked", "1");
    }

    return () => clearInterval(interval);
  }, []);
  return null;
}

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-G8B1YMQCZE", { page_path: location.pathname });
    }
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 48,
      duration: 750,
    });
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", JSON.stringify("ar"));
    }
  }, []);

  return (
    <Router>
      <VisitorPing />
      <PageTracker />
      <ScrollToTop />
      <ToastContainer />
      <StoreAuthProvider>
        <StoreCartProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="join" element={<JoinUs />} />
              <Route path="contact" element={<ConactUsPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="projects" element={<Projects />} />
              <Route path="projects/:categoryParams" element={<Projects />} />
              <Route path="store" element={<StoreLayout />}>
                <Route index element={<Store />} />
                <Route path="category/:categorySlug" element={<StoreCategory />} />
                <Route path="product/:productId" element={<ProductDetail />} />
                <Route path="policies/:policyId" element={<StorePolicies />} />
                <Route path="my-orders" element={<MyOrders />} />
                <Route path="my-orders/:orderId" element={<OrderDetail />} />
                <Route path="wishlist" element={<Wishlist />} />
                <Route path="checkout" element={<Checkout />} />
              </Route>
            </Route>

            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<DashboardIndex />} />
              <Route path="login" element={<Login />} />
              <Route path="login/forget-password" element={<ForgetPassword />} />
              <Route path="login/reset-password" element={<ChangePassword />} />
              <Route path="profile" element={<Profile />} />
              <Route path="add-project" element={<AddProject />} />
              <Route path="edit-project/:id" element={<EditProject />} />
              <Route path="projects" element={<LastProjects />} />
              <Route path="add-product" element={<AddProduct />} />
              <Route path="products" element={<LastProducts />} />
              <Route path="edit-product/:id" element={<EditProduct />} />
              <Route path="messages" element={<Messages />} />
              <Route path="orders" element={<Orders />} />
              <Route path="orders/:orderId" element={<DashboardOrderDetail />} />
              <Route path="store/products" element={<LastProducts />} />
              <Route path="store/add-product" element={<AddProduct />} />
              <Route path="store/edit-product/:id" element={<EditProduct />} />
              <Route path="store/control" element={<StoreControl />} />
              <Route path="store/policies" element={<DashboardPolicies />} />
              <Route path="store/product-reviews" element={<StoreProductReviews />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="add-review" element={<AddReview />} />
              <Route path="reviews" element={<LastReviews />} />
              <Route path="edit-review/:id" element={<EditReview />} />
              <Route path="add-partner" element={<AddPartner />} />
              <Route path="content/home" element={<HomeDash />} />
              <Route path="content/about" element={<About />} />
              <Route path="content/contact-join" element={<ContactJoin />} />
              <Route path="notifications" element={<Notifications />} />
            </Route>
            <Route
              path="/dashbaord/*"
              element={<Navigate to="/dashboard" replace />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </StoreCartProvider>
      </StoreAuthProvider>
    </Router>
  );
}

export default App;
